import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Landing from './pages/Landing';
import Listings from './pages/Listings';
import CleaningListings from './pages/CleaningListings';
import Calendar from './pages/Calendar';
import Checklist from './pages/Checklist';
import Auth from './pages/Auth';
import './i18n';

function App() {
  const { i18n } = useTranslation();

  return (
    <Router>
      <div className="App" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/listings" element={<Listings />} />
            <Route path="/cleaning-listings" element={<CleaningListings />} />
            <Route path="/calendar" element={
              <ProtectedRoute>
                <Calendar />
              </ProtectedRoute>
            } />
            <Route path="/checklist" element={<Checklist />} />
            <Route path="/auth" element={<Auth />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;
